const state = {
    user: null
};

const getters = {
    getUser: state => state.user
};

const mutations = {
    SET_USER(state, user) {
        state.user = user;
    },
    CLEAR_USER(state) {
        state.user = null;
    }
};

const actions = {
    setUser({ commit }, user) {
        commit('SET_USER', user);
    },
    clearUser({ commit }) {
        commit('CLEAR_USER');
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
